import { Mall } from '~domains/partner-application/entities/mall';

export const MALL_OPTION_NONE: Mall = { id: 'NONE', name: 'Not in a mall' };
export const MALL_OPTION_OTHER: Mall = { id: 'OTHER', name: 'Other' };

const additionalOptions = [MALL_OPTION_NONE, MALL_OPTION_OTHER];

export const getMallTitlesMap = (malls: Mall[]) => {
  const titlesMap = malls.reduce<Record<string, string>>((acc, mall) => {
    acc[mall.id] = mall.name;
    return acc;
  }, {});

  additionalOptions.forEach((option) => {
    titlesMap[option.id] = option.name;
  });

  return titlesMap;
};
